(ns practitest.frontend.forms3.entity-form.comments
  (:require [practitest.frontend.common.i18n :refer [format-translation
                                                     get-translation]]
            [practitest.frontend.components.comments :as comments]
            [re-frame.core :as re-frame]))

;; Comments
(defn- comments-panel
  [{:keys [entity-type
           entity-id
           main-state]}]
  [comments/comments-view {:entity-type entity-type
                           :entity-id entity-id
                           :entity-comment? true
                           :main-state main-state}])

(defn comments-tab [entity-type]
  {:tab-id :comments
   :tab-title
   [:span.text-nowrap
    (format-translation
      (get-translation "entity.tab.comments" "Comments (%{n})")
      :n (count @(re-frame/subscribe [::comments/comments entity-type])))]
   :tab-view comments-panel})
